/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SectionModalCreateMutationVariables = {|
  recipeId: string,
  name: string,
|};
export type SectionModalCreateMutationResponse = {|
  +recipeSectionCreate: ?{|
    +recipeSection: ?{|
      +id: string,
      +name: ?string,
    |}
  |}
|};
export type SectionModalCreateMutation = {|
  variables: SectionModalCreateMutationVariables,
  response: SectionModalCreateMutationResponse,
|};
*/


/*
mutation SectionModalCreateMutation(
  $recipeId: ID!
  $name: String!
) {
  recipeSectionCreate(input: {recipe: $recipeId, name: $name}) {
    recipeSection {
      id
      name
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "recipeId",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name",
    "type": "String!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          },
          {
            "kind": "Variable",
            "name": "recipe",
            "variableName": "recipeId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RecipeAddSectionPayload",
    "kind": "LinkedField",
    "name": "recipeSectionCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeSectionNode",
        "kind": "LinkedField",
        "name": "recipeSection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SectionModalCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SectionModalCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "SectionModalCreateMutation",
    "operationKind": "mutation",
    "text": "mutation SectionModalCreateMutation(\n  $recipeId: ID!\n  $name: String!\n) {\n  recipeSectionCreate(input: {recipe: $recipeId, name: $name}) {\n    recipeSection {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'be0d3b9517e38d9827ba645493e6fa5e';

module.exports = node;
